module.exports = __webpack_public_path__ + "media/images/es-32e1e4891a5c1d5ce79f04ec7671d151.svg";